import React from "react";
import styles from "./HospitalitySection.module.css";
const HospitalitySection = () => {

    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>
                Data-Driven Hospitality Decisions            </h2>
            <p>
                Gain insights into traveler behavior, preferences, and trends to optimize <br />
                services and increase loyalty
            </p>
            <div className={styles.wrapper}>
                <div className={styles.featureList}>
                    <div className={styles.item}>
                        <span className={styles.star}></span>
                        <div>
                            <h4>Customer behavior analytics</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.star}></span>
                        <div>
                            <h4>Booking trends & patterns</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.star}></span>
                        <div>
                            <h4>Personalization performance tracking</h4>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default HospitalitySection;
